const useBuildTree = () => {
  const endCode = 999
  var stepColors = [
    { id: -1, color: "#008dff" },
    { id: endCode, color: "red" },
  ];

  const colors = ["green", "orange", "margenta", "gold", "yellow", "cyan", "olive", "khaki", "pink", "brown",  "grey", "black", "blue"];

  const buildTree = (TreeItem, data, step, decision, reduceds, parentsAddedIds, parentsNodeIds = []) => {
    var nextItem = undefined;
    var currentItem = undefined;

    currentItem = data.filter(
      (item) => item.items.data[0].item.id == step.item.id)[0];

    var canAdd = false;
    var isAdded = false;
    if (currentItem) {
      isAdded = isAlreadyAdded(currentItem, parentsAddedIds);
      canAdd = !isAdded;
      parentsAddedIds.push(currentItem.items.data[0].item.id);
      step = {...step, conditionDescription:currentItem.conditionDescription}
      parentsNodeIds.push(currentItem.id)
    }

    var isReduced = reduceds.includes(step.id);
    var newItem = {
      step: step,
      decision: decision,
      childs: [],
      isDiscontinued: isAdded,
      isOvale: step.item.id == endCode,
      isReduced: isReduced,
    };

    TreeItem.push(newItem);

    var index = TreeItem.length - 1;

    

    if (canAdd && !isReduced) {
      var order = currentItem.order;
      parentsAddedIds.push(currentItem.items.data[0].item.id);
      
      if (currentItem.childs.length == 0) {
        nextItem = data.filter(
          (item) => item.order == order + 1
        )[0];
        if (nextItem && nextItem.childs.length > 0) {
          isReduced = reduceds.includes(nextItem.items.data[0].id);
          newItem = {
            step: {...nextItem.items.data[0], conditionDescription:nextItem.conditionDescription}, //nextItem.items.data[0],
            decision: null,
            childs: [],
            isLeaf: false,
            isDiscontinued: isAlreadyAdded(nextItem, parentsAddedIds),
            isOvale: nextItem.items.data[0].item.id == endCode,
            color: colors[0],
            isReduced: isReduced,
          };
          
          parentsAddedIds.push(nextItem.items.data[0].item.id);
          parentsNodeIds.push(nextItem.id)
          TreeItem[index].childs.push(newItem);
          TreeItem = TreeItem[index].childs;
          index = TreeItem.length - 1;
        }
      } else {
        nextItem = JSON.parse(JSON.stringify(currentItem));
      }

      if (nextItem && !isReduced)
        if (nextItem.childs.length > 0) {
          nextItem.childs.map((child) => {
            var stepValue = child.items.data.filter(
              (item) => item.list == "Steps"
            )[0];
            var decisionValue = child.items.data.filter(
              (item) => item.list == "Decisions"
            )[0];

            buildTree(
              TreeItem[index].childs,
              data,
              stepValue,
              decisionValue,
              reduceds,
              parentsAddedIds,
              parentsNodeIds
            );
          });
        } else {
          buildTree(
            TreeItem[index].childs,
            data,
            nextItem.items.data[0],
            null,
            reduceds,
            parentsAddedIds,
            parentsNodeIds
          );
        }
    }
  };

  const isAlreadyAdded = (currentItem, parentsAddedIds) => {
    var currentId = currentItem.items.data[0].item.id;
    var isAdded = parentsAddedIds.includes(currentId);

    if (
      isAdded &&
      stepColors.filter((color) => color.id == currentId).length == 0
    )
      stepColors = [
        ...stepColors,
        {
          id: currentId,
          color: colors[stepColors.length - 2],
        },
      ];
    
    return isAdded;
  };

  return buildTree;
};

export default useBuildTree;
